import { render, staticRenderFns } from "./DataGridSort.vue?vue&type=template&id=42c7cc6d&scoped=true&"
import script from "./DataGridSort.vue?vue&type=script&lang=js&"
export * from "./DataGridSort.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42c7cc6d",
  null
  
)

export default component.exports